const toDataUri = (text: string): string => `data:text/javascript;base64,${btoa(text)}`;

/**
 * A function that creates a Web Worker; useful for attaching and retaining type expectations.
 * @template T The type of the data to be passed to the worker.
 * @template U The type of the data to be returned from the worker.
 */
export type Work<T, U> = () => Worker;

/**
 * Produce a function that creates a Web Worker, which will run the provided function on passed-in data.
 * @template T The type of the data to be passed to the worker.
 * @template U The type of the data to be returned from the worker.
 * @param fn The function to run on the worker.
 * @returns A function that creates a Web Worker.
 */
export default function work<T, U>(fn: (data: T) => U): Work<T, U> {
  const code = `
    const fn = ${fn.toString()};
    onmessage = ({data}) => {
      postMessage(fn(data));
    };
  `;
  const uri = toDataUri(code);
  return () => new Worker(uri);
}
